import { NO_CURRENCY_SYMBOL, fromNumber } from '@migrate/utils/number'

export default function renderCurrency(
  value: number | string,
  fractionDigits?: number,
  currency?: string,
  unit?: string,
) {
  if (value !== undefined && value !== null) {
    const curr: number = typeof value === 'string' ? parseFloat(value) : value

    if (!isNaN(curr)) {
      try {
        return (
          (unit && !currency ? ` ${unit}` : '') +
          fromNumber(curr).toLocalizedCurrencyString(currency ? currency : NO_CURRENCY_SYMBOL, {
            useGrouping: false,
            currencyDisplay: 'code',
            minimumFractionDigits: fractionDigits !== undefined ? fractionDigits : 2,
            maximumFractionDigits: fractionDigits !== undefined ? fractionDigits : 2,
          })
        )
      } catch {
        // users can input invalid currencies.. so do our best to just show something
        return (unit ? ` ${unit}` : '') + curr
      }
    }
  } else {
    value = ''
  }
  return value + ''
}
